/* Help Center — runtime
 * - Sticky TOC active-state via IntersectionObserver
 * - Feedback widget (Yes/No → BettrMetrics + visible thanks)
 * - Chat-trigger handoff (calls window.bettrOpenChat() if defined)
 * - Suggested-search chip → focuses input + prefills query
 *
 * Search itself lives in custom-help-search.js.
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn, { once: true }); }
  }

  /* ---------- TOC active-state ---------- */
  function initToc() {
    var tocLinks = document.querySelectorAll('[data-help-toc-link]');
    if (!tocLinks.length || !('IntersectionObserver' in window)) return;

    var byId = {};
    var ids = [];
    tocLinks.forEach(function (a) {
      var id = a.getAttribute('href');
      if (!id || id.charAt(0) !== '#') return;
      id = id.substring(1);
      var target = document.getElementById(id);
      if (target) { byId[id] = a; ids.push(id); }
    });

    var headerOffset = 80;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var id = entry.target.id;
        var link = byId[id];
        if (!link) return;
        if (entry.isIntersecting) {
          tocLinks.forEach(function (l) { l.classList.remove('is-active'); });
          link.classList.add('is-active');
        }
      });
    }, {
      rootMargin: '-' + headerOffset + 'px 0px -55% 0px',
      threshold: 0
    });

    ids.forEach(function (id) { observer.observe(document.getElementById(id)); });

    // Smooth-scroll TOC clicks on mobile (collapse the open <details> after navigation)
    tocLinks.forEach(function (a) {
      a.addEventListener('click', function () {
        if (window.innerWidth < 1024) {
          var details = document.querySelector('[data-help-article-toc]');
          if (details) details.removeAttribute('open');
        }
      });
    });
  }

  /* ---------- Feedback widget ---------- */
  function initFeedback() {
    var widgets = document.querySelectorAll('[data-help-feedback]');
    if (!widgets.length) return;

    widgets.forEach(function (widget) {
      widget.querySelectorAll('[data-help-feedback-vote]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var vote = btn.getAttribute('data-help-feedback-vote');
          widget.classList.add('is-submitted');

          // Send to BettrMetrics if available
          if (window.BettrMetrics && typeof window.BettrMetrics.mark === 'function') {
            window.BettrMetrics.mark('help-feedback-' + vote);
          }

          // Best-effort beacon for telemetry
          if (window.BETTR_METRICS_ENDPOINT && navigator.sendBeacon) {
            try {
              var payload = new Blob([JSON.stringify({
                type: 'help_feedback',
                vote: vote,
                path: window.location.pathname,
                title: document.title,
                ts: Date.now()
              })], { type: 'application/json' });
              navigator.sendBeacon(window.BETTR_METRICS_ENDPOINT, payload);
            } catch (e) { /* swallow */ }
          }

          // Custom event for any analytics observers
          document.dispatchEvent(new CustomEvent('bettr:help-feedback', {
            detail: { vote: vote, path: window.location.pathname }
          }));
        });
      });
    });
  }

  /* ---------- Chat trigger ----------
     Tries, in order:
       1. window.bettrOpenChat() — custom hook
       2. window.ShopifyChat.openWindow() — Shopify Inbox API (when exposed)
       3. Click the Shopify Inbox launcher iframe / Tidio / generic chat bubble
       4. Fall through to the CTA's href (e.g. /pages/contact) as fallback
  */
  function tryOpenChatWidget() {
    if (typeof window.bettrOpenChat === 'function') {
      try { window.bettrOpenChat(); return true; } catch (e) {}
    }
    if (window.ShopifyChat && typeof window.ShopifyChat.openWindow === 'function') {
      try { window.ShopifyChat.openWindow(); return true; } catch (e) {}
    }
    var selectors = [
      'iframe[id*="shopify-chat"]',
      'iframe[name*="ShopifyChat"]',
      'iframe[id*="ShopifyChat"]',
      'iframe[src*="shopify-chat"]',
      'iframe[src*="/conversations/"]',
      '[data-shopify-chat-launcher]',
      'shopify-chat',
      '#tidio-chat-iframe',
      '#tidio-chat',
      '.intercom-launcher',
      '#intercom-container'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) {
        try {
          el.click();
          if (typeof el.scrollIntoView === 'function') {
            el.scrollIntoView({ behavior: 'smooth', block: 'end' });
          }
          return true;
        } catch (e) {}
      }
    }
    return false;
  }

  function initChatTrigger() {
    var triggers = document.querySelectorAll('[data-help-chat-trigger]');
    if (!triggers.length) return;

    triggers.forEach(function (el) {
      el.addEventListener('click', function (e) {
        if (tryOpenChatWidget()) {
          e.preventDefault();
        }
        // Otherwise let the href take over (fallback URL).
      });
    });
  }

  /* ---------- Suggested-search chips ---------- */
  function initChips() {
    var chips = document.querySelectorAll('[data-help-chip]');
    if (!chips.length) return;
    var input = document.querySelector('[data-help-search-input]');
    if (!input) return;

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        input.value = chip.getAttribute('data-help-chip') || '';
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.focus();
      });
    });
  }

  ready(function () {
    initToc();
    initFeedback();
    initChatTrigger();
    initChips();
  });
})();
